<template>
  <div class="d-flex flex-column" style="height: 88vh; overflow: hidden;">
    
    <v-card class="elevation-1 rounded-0 mb-1 flex-shrink-0" color="grey lighten-5" style="z-index: 2;">
      <v-card-text class="pa-2">
        <div v-if="clienteCodigo" class="mb-2 text-center">
          <div class="text-subtitle-1 font-weight-bold primary--text text-truncate">
            {{ clienteNome }}
          </div>
          <div class="caption grey--text">Código: {{ clienteCodigo }}</div>
        </div>

        <v-row no-gutters justify="center" class="align-center">
          <v-radio-group v-model="tipoVenda" row dense hide-details class="mt-0">
            <v-radio label="Vendas Detalhadas" value="detalhada"></v-radio>
            <v-radio label="Últimas Vendas" value="ultimas"></v-radio>
            
            <v-radio value="perdidos">
              <template v-slot:label>
                <div class="d-flex align-center">
                  <span :class="{'primary--text font-weight-bold': tipoVenda === 'perdidos'}">
                    Produtos Perdidos
                  </span>
                  
                  <v-slide-x-transition>
                    <div v-if="tipoVenda === 'perdidos'" class="d-flex align-center ml-2">
                      <span class="text-caption grey--text mr-1">></span>
                      <v-text-field
                        v-model.number="diasPerdidos"
                        type="number"
                        dense
                        hide-details
                        min="1"
                        class="pa-0 ma-0 compact-input"
                        style="max-width: 40px; font-size: 14px;"
                        @input="processarVendasParaExibicao"
                        @click.stop
                        @keydown.stop
                      ></v-text-field>
                      <span class="text-caption grey--text ml-1">dias</span>
                    </div>
                  </v-slide-x-transition>
                </div>
              </template>
            </v-radio>

          </v-radio-group>
        </v-row>

        <v-row align="center" class="mt-2">
          <v-col cols="10" sm="11">
            <v-autocomplete
              v-model="produtoSelecionado"
              :items="produtosOrdenadosPorCodigo"
              :search-input.sync="searchCodigo"
              item-text="codigoExibicao" 
              item-value="codigoExibicao"
              label="Código Produto"
              placeholder="Digite para buscar..."
              outlined
              dense
              hide-details
              return-object
              no-filter
              clearable
              :loading="loadingBusca"
              :readonly="isBloqueado"
              :background-color="(isBloqueado) ? '#FFF9C4' : ''"
              @keypress="somenteNumeros"
              @paste="filtrarColar"
              @keydown.enter="verificarCodigoDigitado"
            >
              <template v-slot:item="data">
                <v-list-item 
                  v-bind="data.attrs" 
                  v-on="data.on"
                  :style="{ backgroundColor: produtosOrdenadosPorCodigo.indexOf(data.item) % 2 === 0 ? '#f5f5f5' : '#ffffff', width: '100%' }"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.codigointerno || data.item.codigoInterno }} - {{ data.item.descricao }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Preço: {{ Number(data.item.preco || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="2" sm="1" class="pl-0">
            <v-btn fab small dark color="primary" :readonly="isBloqueado" @click="pesquisarProduto">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row align="center" class="mt-2">
          <v-col cols="6">
            <v-autocomplete
              v-model="produtoSelecionado"
              :items="produtosOrdenadosPorNome"
              :search-input.sync="searchNome"
              item-text="descricao"
              item-value="idcortamanhofinal"
              label="Nome Produto"
              placeholder="Digite para buscar..."
              outlined 
              dense 
              hide-details 
              return-object
              no-filter
              clearable
              :loading="loadingBusca"
              :readonly="isBloqueado"
              :background-color="isBloqueado ? '#FFF9C4' : ''"
            >
              <template v-slot:item="data">
                <v-list-item 
                  v-bind="data.attrs" 
                  v-on="data.on"
                  :style="{ backgroundColor: produtosOrdenadosPorNome.indexOf(data.item) % 2 === 0 ? '#f5f5f5' : '#ffffff', width: '100%' }"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.codigointerno || data.item.codigoInterno }} - {{ data.item.descricao }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Preço: {{ Number(data.item.preco || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-autocomplete
              v-model="grupoSelecionado"
              :items="gruposOrdenados"
              :search-input.sync="searchGrupo"
              item-text="descricao"
              item-value="idgrupo"
              label="Grupo Produto"
              placeholder="Digite para buscar..."
              outlined 
              dense 
              hide-details 
              return-object
              clearable
              :filter="filtrarGrupo"
              :loading="loadingGrupos"
              :readonly="isBloqueado"
              :background-color="isBloqueado ? '#FFF9C4' : ''"
            >
              <template v-slot:item="data">
                <v-list-item 
                  v-bind="data.attrs" 
                  v-on="data.on"
                  :style="{ backgroundColor: gruposOrdenados.indexOf(data.item) % 2 === 0 ? '#f5f5f5' : '#ffffff', width: '100%' }"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.idgrupo ? `${data.item.idgrupo} - ` : '' }}{{ data.item.descricao }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row v-if="!veioDeTelaEspecifica" align="center" class="mt-2">
          <v-col cols="3">
            <v-btn small dark color="primary" block @click="voltaTelaVenda">
              <v-icon left small>mdi-arrow-left-thin</v-icon> Tela Venda
            </v-btn>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>

    <div class="content-container flex-grow-1 elevation-1 white" style="position: relative; overflow: hidden;">
      
      <div v-if="loading" class="d-flex justify-center align-center fill-height">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div v-else-if="vendasProcessadas.length === 0" class="d-flex justify-center align-center fill-height grey--text">
        <div class="text-center">
          <v-icon size="48" color="grey lighten-2">mdi-cart-off</v-icon>
          <p class="mt-2">Nenhuma venda encontrada.</p>
        </div>
      </div>

      <simplebar
        v-else
        data-simplebar
        :autoHide="false"
        class="lista-resultados-container"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; height: 100%;"
      >
        <v-list dense class="py-0">
          <template v-for="(item, index) in vendasProcessadas">
            <v-list-item 
              :key="item.idUnico || index" 
              class="px-2 py-1"
              :class="item.corFundo"
            >
              <v-list-item-content>
                <v-list-item-title class="text-body-2 font-weight-bold d-flex justify-space-between">
                  <span class="text-truncate">Venda - {{ item.idvenda }}</span> <span class="font-weight-medium">Data: {{ formatarData(item.data) }}</span>
                </v-list-item-title>

                <v-list-item-title class="text-body-2 font-weight-bold d-flex justify-space-between">
                  <span class="text-truncate">Produto - {{ item.idcortamanhofinal }} - {{ item.descricao }}</span>
                </v-list-item-title>
                
                <v-list-item-subtitle class="black--text mt-1 d-flex justify-space-between flex-wrap">
                  <span>Qtde: <b>{{ formatarDecimal(item.qtde, 3) }}</b></span>
                  <span>Preço: <b>{{ formatarMoeda(item.precoDoProduto) }}</b></span>
                  <span>Total: <b>{{ formatarMoeda(item.valor) }}</b></span>
                  
                </v-list-item-subtitle>
                <v-list-item-subtitle class="black--text mt-1 d-flex justify-space-between flex-wrap">
                  <span>Estoque: <b>{{ formatarDecimal(item.estoque, 0) }}</b></span>
                </v-list-item-subtitle>

              </v-list-item-content>

              <v-list-item-action class="ml-2" v-if="!veioDeTelaEspecifica">
                <v-btn 
                  icon 
                  :color="item.jaNoPedido ? 'orange darken-2' : 'primary'"
                  @click="adicionarAoPedido(item)"
                >
                  <v-icon>{{ item.jaNoPedido ? 'mdi-cart-check' : 'mdi-cart-plus' }}</v-icon>
                </v-btn>
              </v-list-item-action>

            </v-list-item>
            <v-divider v-if="index < vendasProcessadas.length - 1" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </simplebar>
    </div>
  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';
import { mapActions } from 'vuex';

export default {
  name: 'VendasView',

  props: {
    origem: String, 
    idCortamanhofinalInicial: [Number, String]
  },

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      tipoVenda: 'detalhada',
      diasPerdidos: 60,
      produtoCodigo: '',
      produtoNome: '',
      idCortamanhofinalFiltro: null,
      previousRouteName: null,
      itensRecemAdicionados: [],
      clienteNome: '',
      clienteCodigo: null,
      clienteIdVendedor: 0,
      idVendedorLogado: null,

      produtoSelecionado: null,
      produtosEncontrados: [],
      searchCodigo: '',
      searchNome: '',
      item: {
        marca: '',
        unidade: ''
      },
      loadingBusca: false,
      timerBusca: null,

      grupoSelecionado: null,
      listaGrupos: [],
      searchGrupo: '',
      loadingGrupos: false,
      idGrupoFiltro: null,

      vendasRaw: [],
      vendasProcessadas: [],
    };
  },

  computed: {
    bloquearBuscaProduto() {
      return !!this.idCortamanhofinalInicial || this.origem === 'cadastro-pedido-produto';
    },
    isBloqueado() {
      return this.bloquearBuscaProduto;
    },
    gruposOrdenados() {
      return [...this.listaGrupos].sort((a, b) => {
        const descA = String(a.descricao || '');
        const descB = String(b.descricao || '');
        return descA.localeCompare(descB);
      });
    },
    produtosOrdenadosPorCodigo() {
      return [...this.produtosEncontrados].sort((a, b) => {
        const codA = String(a.codigoExibicao || '');
        const codB = String(b.codigoExibicao || '');
        return codA.localeCompare(codB, undefined, { numeric: true });
      });
    },
    produtosOrdenadosPorNome() {
      return [...this.produtosEncontrados].sort((a, b) => {
        const descA = String(a.descricao || '');
        const descB = String(b.descricao || '');
        return descA.localeCompare(descB);
      });
    },
    veioDeTelaEspecifica() {
      const origemAtual = (this.origem || this.$route.query.origem || '').toString().toLowerCase();
      const rotasEspecificas = ['clientes', 'pesquisaclientes', 'cliente'];
      return rotasEspecificas.includes(origemAtual);
    }
  },

  watch: {
    searchCodigo(val) {
      const valStr = val !== null && val !== undefined ? String(val) : "";

      if (valStr) {
        const valorLimpo = valStr.replace(/\D/g, '');
        if (valStr !== valorLimpo) {
          this.$nextTick(() => { this.searchCodigo = valorLimpo; });
          return; 
        }
      }

      if (!valStr) {
        this.buscarNoDexie('', 'codigo');
      } else if (!this.produtoSelecionado || valStr !== String(this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal || this.produtoSelecionado.codigoExibicao)) {
        this.buscarNoDexie(valStr, 'codigo');
      }
    },
    searchNome(val) {
      if (!val) {
        this.buscarNoDexie('', 'nome');
      } else if (!this.produtoSelecionado || val !== this.produtoSelecionado.descricao) {
        this.buscarNoDexie(val, 'nome');
      }
    },
    grupoSelecionado(newVal) {
      if (newVal) {
        const idG = newVal.idgrupo !== undefined && newVal.idgrupo !== null ? newVal.idgrupo : null;
        if (this.idGrupoFiltro !== idG) {
          this.idGrupoFiltro = idG;
          if (this.produtoSelecionado) {
            const prodGrupo = this.produtoSelecionado.idgrupo !== undefined && this.produtoSelecionado.idgrupo !== null
              ? this.produtoSelecionado.idgrupo
              : null;
            if (prodGrupo !== null && String(prodGrupo) !== String(idG)) {
              this.produtoSelecionado = null;
              this.produtoCodigo = '';
              this.produtoNome = '';
              this.idCortamanhofinalFiltro = null;
              this.searchCodigo = '';
              this.searchNome = '';
            }
          }
          this.carregarVendas();
        }
      } else {
        if (this.idGrupoFiltro !== null) {
          this.idGrupoFiltro = null;
          this.searchGrupo = '';
          this.carregarVendas();
        }
      }
    },
    produtoSelecionado(newVal) {
      if (newVal) {
        this.item.marca = newVal.marca || '';
        this.item.unidade = newVal.un || newVal.um || newVal.unidade || '';
        const idParaBusca = parseInt(newVal.idcortamanhofinal || newVal.idCortamanhofinal, 10);
        if (this.idCortamanhofinalFiltro !== idParaBusca) {
          this.idCortamanhofinalFiltro = idParaBusca;
          this.produtoCodigo = newVal.codigointerno || newVal.codigoInterno || String(idParaBusca);
          this.produtoNome = newVal.descricao;

          const dadosProd = {
            id: this.idCortamanhofinalFiltro,
            codigo: this.produtoCodigo,
            descricao: this.produtoNome
          };
          sessionStorage.setItem('filtro_historico_produto', JSON.stringify(dadosProd));

          if (newVal.idgrupo !== undefined && newVal.idgrupo !== null && this.listaGrupos.length > 0) {
            const grupoDoProd = this.listaGrupos.find(g => String(g.idgrupo) === String(newVal.idgrupo));
            if (grupoDoProd && (!this.grupoSelecionado || String(this.grupoSelecionado.idgrupo) !== String(newVal.idgrupo))) {
              this.grupoSelecionado = grupoDoProd;
              this.idGrupoFiltro = grupoDoProd.idgrupo;
            }
          }

          this.carregarVendas();
        }
      } else {
        this.item.marca = '';
        this.item.unidade = '';
        this.searchNome = '';
        if (this.idCortamanhofinalFiltro !== null || this.produtoCodigo || this.produtoNome) {
          this.limparFiltroProduto();
        }
      }
    },
    '$route.query': {
      immediate: true,
      deep: true,
      handler(newQuery, oldQuery) {
        const mudouCliente = newQuery.clienteCodigo && (!oldQuery || newQuery.clienteCodigo != oldQuery.clienteCodigo);
        const temProdutoNaUrl = newQuery.idProdutoSelecao || newQuery.produtoCodigo;
        const voltandoDeSelecao = sessionStorage.getItem('produto_selecionado_retorno');
        if (mudouCliente && !temProdutoNaUrl && !voltandoDeSelecao) {
            this.limparMemoriaProduto();
            this.produtoCodigo = '';
            this.produtoNome = '';
            this.idCortamanhofinalFiltro = null;
            this.grupoSelecionado = null;
            this.idGrupoFiltro = null;
        }

        const mudouProduto = newQuery.idProdutoSelecao && (!oldQuery || newQuery.idProdutoSelecao != oldQuery.idProdutoSelecao);
        const mudouParamsProduto = (newQuery.produtoCodigo && newQuery.produtoCodigo !== this.produtoCodigo);
        if (mudouCliente || mudouProduto || mudouParamsProduto || voltandoDeSelecao) {
          this.lerParametrosRota();
        }
      }
    },
    tipoVenda() {
      this.processarVendasParaExibicao();
    },
  },

  created() {
    if (this.$route.query && (this.$route.query.idgrupo || this.$route.query.idGrupo)) {
      this.idGrupoFiltro = parseInt(this.$route.query.idgrupo || this.$route.query.idGrupo, 10);
    }
    if (this.idCortamanhofinalInicial) {
      this.idCortamanhofinalFiltro = parseInt(this.idCortamanhofinalInicial, 10);
      this.carregarDadosProdutoInicial(this.idCortamanhofinalFiltro);
    }
  },

  mounted() {
    this.carregarGrupos();
    this.verificarRetornoDeProduto();
    this.capturarRetornoVenda();
  },

  methods: {
    ...mapActions('venda', ['getListaPorCliente']),

    async obterVendedorLogado() {
      try {
        const param = await db.parametro.toCollection().first();
        if (param) {
          this.idVendedorLogado = param.idvendedorlogado || param.idVendedorLogado;
        }
      } catch (e) {
        console.error("Erro ao obter idvendedorlogado:", e);
      }
    },

    garantirPositivo(campo) {
      if (this[campo] && this[campo] < 0) {
        this[campo] = Math.abs(this[campo]);
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    capturarRetornoVenda() {      
      const idVenda = sessionStorage.getItem('retornoIdVenda');
      const idProd = sessionStorage.getItem('retornoIdCorTamanhoFinal');
      let acumulado = JSON.parse(sessionStorage.getItem('itensVisuaisLaranja') || '[]');

      if (idVenda && idProd) {
        const chave = `${idVenda}-${idProd}`;
        
        if (!acumulado.includes(chave)) {
            acumulado.push(chave);
        }
        sessionStorage.removeItem('retornoIdVenda');
        sessionStorage.removeItem('retornoIdCorTamanhoFinal');
        sessionStorage.removeItem('retornoIdCliente'); 
      }

      sessionStorage.setItem('itensVisuaisLaranja', JSON.stringify(acumulado));
      this.itensRecemAdicionados = acumulado;
    },

    salvarClienteNoStorage() {
      if (this.clienteCodigo) {
        const dadosParaSalvar = {
          codigo: this.clienteCodigo,
          nome: this.clienteNome || 'Cliente',
          idVendedor: this.clienteIdVendedor || 0
        };
        sessionStorage.setItem('vendasView_clienteAtual', JSON.stringify(dadosParaSalvar));
      }
    },

    limparMemoriaProduto() {
      sessionStorage.removeItem('filtro_historico_produto');
      sessionStorage.removeItem('produto_selecionado_retorno');
    },

    limparFiltroProduto() {
      this.produtoCodigo = '';
      this.produtoNome = '';
      this.idCortamanhofinalFiltro = null;
      this.produtoSelecionado = null;
      this.searchCodigo = '';
      this.searchNome = '';
      this.item.marca = '';
      this.item.unidade = '';
      this.produtosEncontrados = [];
      
      this.limparMemoriaProduto();
      this.carregarVendas();
    },

    async verificarRetornoDeProduto() {
      const dadosStr = sessionStorage.getItem('produto_selecionado_retorno');
      if (dadosStr) {
        try {
          const dados = JSON.parse(dadosStr);
          sessionStorage.removeItem('produto_selecionado_retorno');

          this.produtoCodigo = dados.codigo;
          this.produtoNome = dados.descricao;
          this.idCortamanhofinalFiltro = parseInt(dados.id);

          if (this.idCortamanhofinalFiltro) {
            await this.carregarDadosProdutoInicial(this.idCortamanhofinalFiltro);
          }

          this.$nextTick(() => {
            this.carregarVendas();
          });
        } catch (e) {
          console.error("Erro ao ler retorno:", e);
        }
      }
    },

    async lerParametrosRota() {
      let { 
        clienteCodigo, 
        clienteNome, 
        clienteIdVendedor, 
        idProdutoSelecao,  
        produtoCodigo,
        produtoNome 
      } = this.$route.query;

      if (!idProdutoSelecao && !produtoCodigo) {
        let jsonBackup = sessionStorage.getItem('produto_selecionado_retorno');
        if (!jsonBackup) {
            jsonBackup = sessionStorage.getItem('filtro_historico_produto');
        }
        if (jsonBackup) {
          try {
            const dados = JSON.parse(jsonBackup);
            if (dados && (dados.id || dados.codigo)) {
                idProdutoSelecao = dados.id;
                produtoCodigo = dados.codigo;
                produtoNome = dados.descricao;
            }
          } catch (e) {
            console.error("Erro ao ler backup do produto:", e);
          }
        }
      }

      const STORAGE_KEY = 'vendasView_clienteAtual';

      if (!clienteCodigo) {
        const salvo = sessionStorage.getItem(STORAGE_KEY);
        if (salvo) {
          try {
            const dados = JSON.parse(salvo);
            if (dados && dados.codigo) {
              clienteCodigo = dados.codigo;
              clienteNome = dados.nome;
              clienteIdVendedor = dados.idVendedor;
            }
          } catch (e) { console.error(e); }
        }
      } 
      
      if (clienteCodigo) {
        this.clienteCodigo = parseInt(clienteCodigo);
        this.clienteNome = clienteNome || this.clienteNome || 'Cliente';
        this.clienteIdVendedor = parseInt(clienteIdVendedor) || 0;
        this.salvarClienteNoStorage();
      }

      if (produtoCodigo) this.produtoCodigo = produtoCodigo;
      if (produtoNome) this.produtoNome = produtoNome;

      if (idProdutoSelecao) {
        const idProd = parseInt(idProdutoSelecao);
        this.idCortamanhofinalFiltro = idProd;

        if (!this.produtoCodigo || !this.produtoNome || !this.produtoSelecionado) {
          await this.carregarDadosProdutoInicial(idProd);
        }
      } else if (!produtoCodigo) {
        if (!this.idCortamanhofinalInicial) {
            this.idCortamanhofinalFiltro = null;
            this.produtoCodigo = '';
            this.produtoNome = '';
            this.produtoSelecionado = null;
        }
      }

      if (this.clienteCodigo) {
        this.$nextTick(() => {
            this.carregarVendas();
        });
      }
    },

    abrirPesquisaProduto() {
      this.salvarClienteNoStorage();
      this.$router.push({
        path: '/cadastro-pedido-produto',
        query: { 
            origem: 'consulta-vendas',
            clienteCodigo: this.clienteCodigo 
        } 
      });
    },

    pesquisarProduto() {
      this.abrirPesquisaProduto();
    },

    voltaTelaVenda() {
      this.salvarClienteNoStorage();

      if (this.clienteCodigo) {
        sessionStorage.setItem('retornoIdCliente', this.clienteCodigo);
      }

      const backupPedido = sessionStorage.getItem('pedidoEmEdicao');
      let idPedido = null;

      if (backupPedido) {
        try {
          const backupObj = JSON.parse(backupPedido);
          if (backupObj && backupObj.formData && backupObj.formData.idpedido) {
            idPedido = backupObj.formData.idpedido;
          }
        } catch (e) {
          console.error("Erro ao ler backup do pedido:", e);
        }
      }

      if (!idPedido) {
        const idSessao = sessionStorage.getItem('retornoIdPedido');
        if (idSessao && idSessao !== 'null' && idSessao !== 'undefined') {
          idPedido = idSessao;
        }
      }

      if (idPedido) {
        this.$router.push({
          path: '/cadastro-pedido',
          query: { id: idPedido }
        });
      } else {
        this.$router.push({
          path: '/cadastro-pedido'
        });
      }
    },

    somenteNumeros(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    filtrarColar(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('Text');
      if (/\D/.test(pastedData)) {
        event.preventDefault();
      }
    },

    async obterProdutoDexie(codigo, porId = false) {
      if (!codigo) return null;
      try {
        const idNum = !isNaN(Number(codigo)) ? Number(codigo) : codigo;
        const idStr = String(codigo).trim();

        if (porId) {
          let prod = await db.produto.where('idcortamanhofinal').equals(codigo).first();
          if (!prod && idNum !== codigo) prod = await db.produto.where('idcortamanhofinal').equals(idNum).first();
          if (!prod) prod = await db.produto.where('idcortamanhofinal').equals(idStr).first();
          if (!prod && db.produto.get) {
            prod = await db.produto.get(idNum) || await db.produto.get(idStr);
          }
          return prod;
        } else {
          let prod = await db.produto.where('codigointerno').equals(codigo).first();
          if (!prod && idNum !== codigo) prod = await db.produto.where('codigointerno').equals(idNum).first();
          if (!prod) prod = await db.produto.where('codigointerno').equals(idStr).first();
          return prod;
        }
      } catch (e) {
        console.error("Erro ao obter produto no Dexie:", e);
        return null;
      }
    },

    async verificarCodigoDigitado() {
      if (!this.searchCodigo) return;
      const codigoLimpo = String(this.searchCodigo).trim();
      const prod = await this.obterProdutoDexie(codigoLimpo, true)
        || await this.obterProdutoDexie(codigoLimpo, false);
      if (prod) {
        prod.codigoExibicao = String(prod.idcortamanhofinal || prod.idCortamanhofinal || '');
        this.produtosEncontrados = [prod];
        this.produtoSelecionado = prod;
      }
    },

    filtrarGrupo(item, queryText) {
      if (!queryText) return true;
      const texto = queryText.toLowerCase().trim();
      const desc = String(item.descricao || '').toLowerCase();
      const id = String(item.idgrupo || '').toLowerCase();
      return desc.includes(texto) || id.includes(texto);
    },

    async carregarGrupos() {
      this.loadingGrupos = true;
      try {
        let grupos = [];
        if (db.grupo) {
          grupos = await db.grupo.toArray();
        }

        if (!grupos || grupos.length === 0) {
          if (db.produto) {
            const produtosComGrupo = await db.produto
              .filter(p => p.idgrupo !== undefined && p.idgrupo !== null && p.idgrupo !== '')
              .toArray();

            const mapaGrupos = new Map();
            produtosComGrupo.forEach(p => {
              const idG = p.idgrupo;
              if (idG !== undefined && idG !== null && !mapaGrupos.has(String(idG))) {
                mapaGrupos.set(String(idG), {
                  idgrupo: idG,
                  descricao: p.descricaogrupo || `Grupo ${idG}`
                });
              }
            });
            grupos = Array.from(mapaGrupos.values());
          }
        }

        this.listaGrupos = grupos
          .map(g => ({
            idgrupo: g.idgrupo !== undefined && g.idgrupo !== null ? g.idgrupo : g.IdGrupo,
            descricao: g.descricao || g.Descricao || g.nome || (g.idgrupo ? `Grupo ${g.idgrupo}` : 'Sem descrição')
          }))
          .filter(g => g.idgrupo !== undefined && g.idgrupo !== null);

        if (this.idGrupoFiltro && !this.grupoSelecionado) {
          const encontrado = this.listaGrupos.find(g => String(g.idgrupo) === String(this.idGrupoFiltro));
          if (encontrado) {
            this.grupoSelecionado = encontrado;
          }
        } else if (this.produtoSelecionado && this.produtoSelecionado.idgrupo && !this.grupoSelecionado) {
          const encontrado = this.listaGrupos.find(g => String(g.idgrupo) === String(this.produtoSelecionado.idgrupo));
          if (encontrado) {
            this.grupoSelecionado = encontrado;
            this.idGrupoFiltro = encontrado.idgrupo;
          }
        }
      } catch (e) {
        console.error("Erro ao carregar grupos:", e);
      } finally {
        this.loadingGrupos = false;
      }
    },

    buscarNoDexie(termo, tipo) {
      clearTimeout(this.timerBusca);
      this.timerBusca = setTimeout(async () => {
        this.loadingBusca = true;
        try {
          let resultados = [];
          if (!termo) {
            if (this.idGrupoFiltro) {
              resultados = await db.produto
                .filter(p => String(p.idgrupo) === String(this.idGrupoFiltro))
                .limit(30)
                .toArray();
            } else {
              resultados = await db.produto.limit(10).toArray();
            }
          } else {
            const queryTerm = termo.toLowerCase();
            if (tipo === 'codigo') {
              resultados = await db.produto
                .filter(p => {
                  if (this.idGrupoFiltro && String(p.idgrupo) !== String(this.idGrupoFiltro)) {
                    return false;
                  }
                  const cod = String(p.idcortamanhofinal || p.idCortamanhofinal || '');
                  const codInterno = String(p.codigointerno || p.codigoInterno || '');
                  return cod.toLowerCase().includes(queryTerm) || codInterno.toLowerCase().includes(queryTerm);
                })
                .limit(30)
                .toArray();
            } else {
              resultados = await db.produto
                .filter(p => {
                  if (this.idGrupoFiltro && String(p.idgrupo) !== String(this.idGrupoFiltro)) {
                    return false;
                  }
                  const desc = String(p.descricao || '');
                  return desc.toLowerCase().includes(queryTerm);
                })
                .limit(30)
                .toArray();
            }
          }

          this.produtosEncontrados = resultados.map(p => ({
            ...p,
            codigoExibicao: String(p.idcortamanhofinal || p.idCortamanhofinal || '')
          }));

          if (tipo === 'codigo') {
            this.produtosEncontrados.sort((a, b) => {
              const codA = a.codigoExibicao || '';
              const codB = b.codigoExibicao || '';
              return codA.localeCompare(codB, undefined, { numeric: true });
            });
          }

          if (this.produtoSelecionado) {
            const idSelecionado = String(this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal);
            const jaExiste = this.produtosEncontrados.some(p => String(p.idcortamanhofinal || p.idCortamanhofinal) === idSelecionado);
            if (!jaExiste) {
              this.produtosEncontrados.push(this.produtoSelecionado);
            }
          }
        } catch (error) {
          console.error("Erro na busca do Dexie:", error);
        } finally {
          this.loadingBusca = false;
        }
      }, 400);
    },

    async aplicarFiltros() {
      if (this.produtoSelecionado) {
        this.idCortamanhofinalFiltro = parseInt(this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal, 10);
      } else if (this.searchCodigo) {
        await this.verificarCodigoDigitado();
      }
      this.carregarVendas();
    },

    async carregarDadosProdutoInicial(id) {
      if (!id) return;
      try {
        const prod = await this.obterProdutoDexie(id, true);
        if (prod) {
          prod.codigoExibicao = String(prod.idcortamanhofinal || prod.idCortamanhofinal || '');
          this.produtosEncontrados = [prod];
          this.produtoSelecionado = prod;
          this.produtoCodigo = prod.codigoInterno || prod.codigointerno;
          this.produtoNome = prod.descricao;
          this.item.marca = prod.marca || '';
          this.item.unidade = prod.un || prod.um || prod.unidade || '';
          if (prod.idgrupo && this.listaGrupos.length > 0) {
            const grp = this.listaGrupos.find(g => String(g.idgrupo) === String(prod.idgrupo));
            if (grp) {
              this.grupoSelecionado = grp;
              this.idGrupoFiltro = grp.idgrupo;
            }
          }
        }
      } catch (e) {
        console.error("Erro ao carregar produto inicial", e);
      }
    },

    _getIdProduto(obj) {
      return parseInt(obj.idcortamanhofinal || obj.IdCorTamanhoFinal || obj.idCortamanhofinal || 0);
    },

    async carregarVendas() {
      if (!this.clienteCodigo) {
        this.vendasProcessadas = [];
        return;
      }
      
      this.loading = true;
      try {
        if (!this.idVendedorLogado) {
          await this.obterVendedorLogado();
        }

        let resultados = [];
        let collection = db.venda.where('idcliente').equals(this.clienteCodigo)
          .filter(v => v.idvendedor === this.idVendedorLogado);

        let idsProdutosDoGrupo = null;
        if (this.idGrupoFiltro) {
          const idGrupoStr = String(this.idGrupoFiltro);
          const produtosDoGrupo = await db.produto
            .filter(p => String(p.idgrupo) === idGrupoStr)
            .toArray();
          idsProdutosDoGrupo = new Set(
            produtosDoGrupo.map(p => parseInt(p.idcortamanhofinal || p.IdCorTamanhoFinal || p.idproduto))
          );
        }

        if (this.idCortamanhofinalFiltro) {
          collection = collection.filter(v => {
            const idProd = this._getIdProduto(v);
            return idProd === this.idCortamanhofinalFiltro;
          });
        } else if (idsProdutosDoGrupo) {
          collection = collection.filter(v => {
            const idProd = this._getIdProduto(v);
            return idsProdutosDoGrupo.has(idProd);
          });
        }
        
        resultados = await collection.toArray();

        if ((!resultados || resultados.length === 0) && !this.idCortamanhofinalFiltro) {
          const params = {
            IdCliente: this.clienteCodigo,
            IdVendedor: this.idVendedorLogado
          };
          
          if (typeof this.getListaPorCliente === 'function') {
            const dadosApi = await this.getListaPorCliente(params);
            if (dadosApi && dadosApi.length > 0) {
              let dadosFiltrados = dadosApi;
              if (idsProdutosDoGrupo) {
                dadosFiltrados = dadosFiltrados.filter(item => {
                  const idCtf = parseInt(item.IdCorTamanhoFinal || item.IdCortamanhofinal || item.idcortamanhofinal);
                  return idsProdutosDoGrupo.has(idCtf);
                });
              }
              resultados = dadosFiltrados.map(item => ({
                idvenda: item.idvenda,
                idcliente: item.IdCliente,
                idcortamanhofinal: item.IdCorTamanhoFinal || item.IdCortamanhofinal,
                descricao: item.Descricao,
                data: item.Data,
                qtde: item.Qtde,
                valor: item.Valor,
                estoque: 0 
              }));
            }
          }
        }

        resultados.sort((a, b) => {
          const dataA = new Date(a.data || a.Data);
          const dataB = new Date(b.data || b.Data);
          return dataB - dataA; 
        });

        this.vendasRaw = resultados;
        await this.processarVendasParaExibicao();

      } catch (error) {
        this.vendasProcessadas = [];
      } finally {
        this.loading = false;
      }
    },

    async processarVendasParaExibicao() {
      let listaExibicao = [...this.vendasRaw];

      if (this.tipoVenda === 'ultimas' || this.tipoVenda === 'perdidos') {
          const mapProdutos = new Map();
          listaExibicao.forEach(v => {
            const idProd = this._getIdProduto(v);
            if (!mapProdutos.has(idProd)) {
              mapProdutos.set(idProd, v);
            }
          });
          listaExibicao = Array.from(mapProdutos.values());
          if (this.tipoVenda === 'perdidos') {
              const dataAtual = new Date();
              dataAtual.setHours(0, 0, 0, 0); 
              
              listaExibicao = listaExibicao.filter(venda => {
                  if (!venda.data && !venda.Data) return false;
                  
                  const dataVenda = new Date(venda.data || venda.Data);
                  dataVenda.setHours(0, 0, 0, 0);
                  const diffTempo = Math.abs(dataAtual - dataVenda);
                  const diffDias = Math.ceil(diffTempo / (1000 * 60 * 60 * 24));
                  return diffDias >= (this.diasPerdidos || 0); 
              });
          }
      }
      const idsProdutos = [...new Set(listaExibicao.map(v => this._getIdProduto(v)))];
      
      let produtosLocais = [];
      try {
        if (idsProdutos.length > 0) {
            produtosLocais = await db.produto
            .where('idcortamanhofinal')
            .anyOf(idsProdutos)
            .toArray();
        }
      } catch (e) { console.warn("Erro ao buscar produtos locais", e); }
      
      const produtoMap = {};
      produtosLocais.forEach(p => {
          const idP = parseInt(p.idcortamanhofinal || p.IdCorTamanhoFinal);
          produtoMap[idP] = p;
      });
      
      const itensNoPedidoSet = new Set();
      const pedidoAtualStr = sessionStorage.getItem('pedidoAtualItens');
      if (pedidoAtualStr) {
        try { 
            const parsed = JSON.parse(pedidoAtualStr);
            if (Array.isArray(parsed)) {
              parsed.forEach(i => {
                const iVenda = i.idvenda || i.IdVenda || i.idVenda; 
                const iProd = i.idcortamanhofinal || i.IdCorTamanhoFinal || i.idCortamanhofinal;
                if (iVenda && iProd) {
                  itensNoPedidoSet.add(`${iVenda}-${iProd}`);
                }
              });
            }
        } catch(e) { console.error("Erro ao ler pedido atual", e); }
      }

      if (this.itensRecemAdicionados && this.itensRecemAdicionados.length > 0) {
        this.itensRecemAdicionados.forEach(chave => {
          itensNoPedidoSet.add(chave);
        });
      }
      let ultimaData = "";
      let corAtual = "bg-white"; 

      this.vendasProcessadas = listaExibicao.map(venda => {
        const idProd = this._getIdProduto(venda); 
        const prodLocal = produtoMap[idProd] || {};
        
        const dataVendaStr = venda.data ? String(venda.data).substring(0, 10) : '';
        if (ultimaData !== '' && dataVendaStr !== ultimaData) {
          corAtual = corAtual === "bg-white" ? "bg-alternate" : "bg-white";
        }
        ultimaData = dataVendaStr;

        const descricaoFinal = prodLocal.descricao || venda.descricao || 'Produto sem nome';
        const idVenda = venda.idvenda || venda.IdVenda;
        const chaveParaVerificar = `${idVenda}-${idProd}`;
        const estaLaranja = itensNoPedidoSet.has(chaveParaVerificar);

        return {
          ...venda,
          idUnico: idVenda + '_' + idProd,
          idcortamanhofinal: idProd,
          descricao: descricaoFinal,
          estoque: prodLocal.estoque !== undefined ? prodLocal.estoque : 0, // Alteração aqui: garante o estoque atualizado do indexedDB
          precoDoProduto: prodLocal.preco || prodLocal.precoVenda || venda.valor || 0, // Alteração aqui: pega o preço do cadastro do produto (mude o nome do campo se necessário)
          corFundo: corAtual,
          jaNoPedido: estaLaranja
        };
      });
    },

    async buscarProdutoPeloCodigo() {
      if (!this.produtoCodigo) {
        this.limparFiltroProduto();
        return;
      }

      try {
        this.idCortamanhofinalFiltro = null; 
        
        let produto = await db.produto
          .where('codigointerno')
          .equals(this.produtoCodigo)
          .first();
        
        if (!produto) {
            produto = await db.produto
            .where('codigoInterno')
            .equals(this.produtoCodigo)
            .first();
        }

        if (produto) {
          this.produtoNome = produto.descricao;
          this.idCortamanhofinalFiltro = parseInt(produto.idcortamanhofinal || produto.IdCorTamanhoFinal);
          produto.codigoExibicao = String(this.idCortamanhofinalFiltro || '');
          this.produtosEncontrados = [produto];
          this.produtoSelecionado = produto;
          this.item.marca = produto.marca || '';
          this.item.unidade = produto.un || produto.um || produto.unidade || '';
        
          const dadosProd = {
              id: this.idCortamanhofinalFiltro,
              codigo: this.produtoCodigo,
              descricao: this.produtoNome
          };
          sessionStorage.setItem('filtro_historico_produto', JSON.stringify(dadosProd));
          this.carregarVendas();
        } else {
          this.produtoNome = "Produto não encontrado";
          this.idCortamanhofinalFiltro = null;
          this.produtoSelecionado = null;
          this.item.marca = '';
          this.item.unidade = '';
        }
      } catch (error) {
        console.error("Erro busca produto:", error);
      }
    },
    
    adicionarAoPedido(item) {
      this.$router.push({
        path: '/cadastro-pedido-item',
        query: {
          idproduto: item.idcortamanhofinal,
          qtde: item.qtde,
          idvenda: item.idvenda,
          idcliente: item.idcliente,
        },
      });
    },

    formatarMoeda(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },
    formatarDecimal(valor, casas = 3) {
      const v = parseFloat(valor);
      if (isNaN(v)) return '0';
      return v.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    },
    formatarData(dataStr) {
      if (!dataStr) return '-';
      try {
        const date = new Date(dataStr);
        if (isNaN(date.getTime())) return String(dataStr).substring(0, 10);
        return date.toLocaleDateString('pt-BR');
      } catch (e) {
        return String(dataStr).substring(0, 10);
      }
    }
  }
};
</script>

<style scoped>
.bg-white {
  background-color: #ffffff;
}
.bg-alternate {
  background-color: #f5f5f5;
}
.lista-resultados-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}
.compact-input ::v-deep input {
  text-align: center;
  padding-top: 2px;
  padding-bottom: 2px;
}

.compact-input ::v-deep input[type=number]::-webkit-inner-spin-button, 
.compact-input ::v-deep input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
.compact-input ::v-deep input[type=number] {
  -moz-appearance: textfield;
}
</style>